import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action, computed } from '@ember/object';
import { Periods } from 'cio/utils/metrics/common';
import { LAST_30_DAYS_RANGE_PRESET_UTC } from 'cio/utils/workflow-metrics';
import moment from 'moment-timezone';
import AnalyticsService from 'cio/services/analytics';
import EnvironmentService from 'cio/services/environment';
import { Grouping } from 'cio/utils/metrics/resolution';
import { TimeRange } from 'cio/utils/time';

const DEFAULT_FORMAT = 'YYYY-MM-DD';

export default class TransactionalBaseMetricsController extends Controller {
  @service analytics!: AnalyticsService;
  @service environment!: EnvironmentService;

  queryParams = [
    {
      grouping: { as: 'group' },
      startTime: { as: 'start_time' },
      endTime: { as: 'end_time' },
    },
  ];

  grouping = Grouping.Daily;
  startTime!: string;
  endTime!: string;

  @computed('startTime', 'endTime')
  get timeRange() {
    return {
      start: moment(this.startTime),
      end: moment(this.endTime),
    };
  }

  @action
  onGroupingChange(value: Periods) {
    this.set('grouping', value);
    this.trackFiltersChange('grouping');
  }

  @action
  onRangeSelect({ date }: { date: TimeRange }) {
    this.setRange(date);
    this.trackFiltersChange('timeframe');
  }

  setDefaults() {
    this.set('grouping', Grouping.Daily);

    if (!this.startTime || !this.endTime) {
      this.setRange(LAST_30_DAYS_RANGE_PRESET_UTC.getRange());
    }
  }

  private setRange(range: TimeRange) {
    this.setProperties({
      startTime: range.start?.format(DEFAULT_FORMAT),
      endTime: range.end?.format(DEFAULT_FORMAT),
    });
  }

  private trackFiltersChange(editType: 'grouping' | 'timeframe') {
    this.analytics.track('transactional', 'timeframe_filters_changed', {
      timeRange: this.timeRange,
      groupBy: this.grouping,
      editType,
    });
  }
}
